module.exports = __webpack_public_path__ + "sansg/img/sy.f7887919.jpg";